import React from 'react';
import ReactSVG from 'react-svg';

import iconFile from 'appSrc/v5/assets/icons/wildlife/menu-burger.svg';

const MenuIcon = ( props ) => {
    const className = `icon-wrapper ${ props.className || '' }`.trim();

    return (
        <ReactSVG src={ iconFile }
        wrapper='div'
        { ...props }
        className={ className } />
    );
};
MenuIcon.defaultProps = {
    className: '',
};

export default MenuIcon;
